import { appActions } from "../../action";
const initialState = {
  isOpenSidebar:false
};

export const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case appActions.HANDLE_MODAL:
      return {
        ...state,
        [Object.keys(action.payload)?.[0]]: action.payload[Object.keys(action.payload)?.[0]],
      };
    default:
      return { ...state, isLoading: false };
  }
};
